export class ProlongationDenialInfo {}